import React from 'react';
import { RadioBox } from '..';

import { FlexRow } from '../FlexRow';

export const NullBooleanSelector = ({ item, className = '', onChangeItem = () => {} }) => {
  return (
    <FlexRow className={className}>
      <RadioBox checked={item.value === 2} labelClassName="mr-0" className="mr-4" label="N/A" onClick={() => onChangeItem({ ...item, value: 2 })} />
      <RadioBox checked={item.value === 1} labelClassName="mr-0" className="mr-4" label="Yes" onClick={() => onChangeItem({ ...item, value: 1 })} />
      <RadioBox checked={item.value === 0} labelClassName="mr-0" className="mr-4" label="No" onClick={() => onChangeItem({ ...item, value: 0 })} />
    </FlexRow>
  );
};
